module.exports = __webpack_public_path__ + "img/hg-card.6dad81c3.png";